import { ApprovalsListResponse } from '@Types/api/approvalsList';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ApprovalsListState {
  approvalsList: Array<ApprovalsListResponse>;
  openModalApprove: boolean;
  openModalReject: boolean;
}

const initialState: ApprovalsListState = {
  approvalsList: [],
  openModalApprove: false,
  openModalReject: false,
};

const approvalsListSlice = createSlice({
  name: 'approvalsList',
  initialState,
  reducers: {
    setTaskListRequest: (
      state: ApprovalsListState,
      action: PayloadAction<Array<ApprovalsListResponse>>
    ) => {
      state.approvalsList = action.payload;
    },
    setOpenModalApprove: (
      state: ApprovalsListState,
      action: PayloadAction<boolean>
    ) => {
      state.openModalApprove = action.payload;
    },
    setOpenModalReject: (
      state: ApprovalsListState,
      action: PayloadAction<boolean>
    ) => {
      state.openModalReject = action.payload;
    },
  },
});

const { actions } = approvalsListSlice;

export const approvalsListActions = {
  ...actions,
};

export default approvalsListSlice;
